import firebase from 'firebase';

const config = {
  apiKey: "AIzaSyAgakmNGlEKvoOzR6FGzTOdojyCbC71nww",
  authDomain: "dsn-app.firebaseapp.com",
  databaseURL: "https://dsn-app.firebaseio.com",
  projectId: "dsn-app",
  storageBucket: "dsn-app.appspot.com",
  messagingSenderId: "186668074387"
};

firebase.initializeApp(config);
export const database = firebase.database();
export const auth =  firebase.auth;



// WEBPACK FOOTER //
// ./src/config/constants/database.js